<div class="ag-filter-wrapper">
  <div class="ag-filter-body-wrapper">
    <div class="ag-filter-filter custom-repository-filter">
      <mat-form-field
        appearance="outline"
        class="ag-filter-operator-select"
        style="width: 100%"
      >
        <mat-select
          [(ngModel)]="filterType"
          (selectionChange)="onFilterTypeChange()"
          (click)="$event.stopPropagation()"
          (openedChange)="onOperatorSelectOpenedChange($event)"
          panelClass="ag-filter-operator-panel"
        >
          <mat-option
            value="contains"
            (click)="$event.stopPropagation()"
          >Enthält
          </mat-option>

          <mat-option
            value="notContains"
            (click)="$event.stopPropagation()"
          >
            Enthält nicht
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="ag-filter-operator-select selection-list-wrapper">
      <mat-selection-list
        [style.overflow-y]="'auto'"
        (selectionChange)="onSelectionChange()"
      >
        @for (option of enumValues; track option) {
          <mat-list-option
            [value]="option"
            [selected]="isSelected(option)"
            (click)="$event.stopPropagation()"
          >
            {{ option }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>


    <div class="ag-filter-apply-panel">
      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="applyFilter()"
      >
        Anwenden
      </button>

      <button
        type="button"
        class="ag-standard-button ag-filter-apply-panel-button"
        (click)="clearFilter()"
      >
        Zurücksetzen
      </button>
    </div>
  </div>
</div>
